import { Component, OnInit } from "@angular/core"
import { BaseService } from "src/app/services/base.service"
import { environment } from "src/environments/environment"

@Component({
	selector: "app-catalog-transport",
	templateUrl: "./catalog-transport.component.html",
	styleUrls: ["./catalog-transport.component.scss"]
})
export class CatalogTransportComponent implements OnInit {
	services: any
	waveValues: any
	coloValues: any
	wave_values10g: any
	wave_values100g: any
	colo_values: any
	public assets_version = environment.ASSETS_VERSION

	constructor(public baseService: BaseService) {}

	ngOnInit() {
		this.baseService.getServicesTransportAndColo().subscribe(res => {
			this.services = res
			if (res) {
				let wavelength = this.services.transportAndColo.filter(e => e.name === "Wavelength")[0]
				let colocation = this.services.transportAndColo.filter(e => e.name === "Colocation")[0]
				const groupedWave = this.groupBy(wavelength.pricelists, key => key.type)
				const groupedColo = this.groupBy(colocation.pricelists, key => key.type)
				this.wave_values10g = groupedWave.get("10G lease standard price")
				this.wave_values100g = groupedWave.get("100G lease standard price")
				this.colo_values = groupedColo.get("600mmx300mm N3 Module with 1Kw")
				this.waveValues = [
					{ type: "10G lease standard price", values: this.wave_values10g },
					{ type: "100G lease standard price", values: this.wave_values100g }
				]
				this.coloValues = [{ type: "600mmx300mm N3 Module with 1Kw", values: this.colo_values }]
			}
		})
	}

	groupBy(list, keyGetter) {
		const map = new Map()
		list.forEach(item => {
			const key = keyGetter(item)
			const collection = map.get(key)
			if (!collection) {
				map.set(key, [item])
			} else {
				collection.push(item)
			}
		})
		return map
	}
}
